export default __webpack_public_path__ + "static/media/download_appstore_color.5ee568d8.svg";